import React from "react";

function Icon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fillRule="evenodd"
      strokeLinejoin="round"
      strokeMiterlimit="2"
      clipRule="evenodd"
      viewBox="0 0 279 279"
      width={props.width}
      className={props.svgClass}
    >
      <g transform="matrix(.978 0 0 1.12929 6.13 96.141)">
        <path fill="none" d="M-6.268 -85.134H278.495V161.481H-6.268z"></path>
        <path
          className={props.pathClass}
          d="M12116.6 2537.42c5.1 0 9.2-4.1 9.2-9.16v-143.15c0-5.06-4.1-9.17-9.2-9.17h-260c-5 0-9.1 4.1-9.1 9.16-.1 23.16-.2 119.96-.2 143.15 0 2.43 1 4.76 2.7 6.49 1.7 1.72 4 2.68 6.5 2.68h260.1zm-158.5-66.01l22.8 18.37c3.3 2.71 8.1 2.71 11.5 0l22.7-18.37 53.4 43.1h-163.8l53.4-43.1zm-87.9-70.95v112.44l69.7-56.22-69.7-56.22zm163.2 56.22l69.5 56.09V2400.6l-69.5 56.08zm-128.7-57.82l81.9 66.11 81.9-66.11h-163.8z"
          transform="matrix(1.02251 0 0 .88551 -12120.2 -2085.44)"
        ></path>
      </g>
    </svg>
  );
}

export default Icon;
